import config from "config/config";
import { authService } from "./authService";
import { createUrlSearchParams } from "helpers";

export const chatService = {
    createConversation,
    getConversation,
    getAllConversations,
    sendChat,
    updateChatData,
    updateConversation,
    createForecast,
    deleteConversation,
    getSalesTargetForecast,
    saveTargetForecast,
};

async function createConversation(data: Record<string, any> | Array<Record<string, any>>) {
    const requestOptions = {
        method: "POST",
        body: JSON.stringify(data),
    };

    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/chat/conversation`,
        requestOptions
    );
    return res;
}

async function updateConversation(data: Record<string, any> | Array<Record<string, any>>) {
    const requestOptions = {
        method: "PUT",

        body: JSON.stringify(data),
    };

    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/chat/conversation`,
        requestOptions
    );
    return res;
}
async function getConversation(conversationId: string) {
    const requestOptions = {
        method: "GET",
    };

    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/chat?conversationId=${conversationId}`,
        requestOptions
    );
    return res;
}

async function getAllConversations(limit?: number | string, page?: number | string) {
    const requestOptions = {
        method: "GET",
    };

    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/chat/conversations/co-pilot?limit=${limit}${
            page ? `&page=${page}` : ""
        }`,
        requestOptions
    );
    return res;
}

async function sendChat(data: Record<string, any> | Array<Record<string, any>>) {
    const requestOptions = {
        method: "POST",
        body: JSON.stringify(data),
    };

    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/chat/send-ai`,
        requestOptions
    );
    return res;
}

async function updateChatData(data: Record<string, any> | Array<Record<string, any>>) {
    const requestOptions = {
        method: "PUT",
        body: JSON.stringify(data),
    };

    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/chat/chat-data`,
        requestOptions
    );
    return res;
}

async function createForecast(data: Record<string, any> | Array<Record<string, any>>) {
    const requestOptions = {
        method: "POST",
        body: JSON.stringify(data),
    };

    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/forecast-sales-target/bulk-create`,
        requestOptions
    );

    return res;
}

async function deleteConversation(id: string) {
    const requestOptions = {
        method: "DELETE",
    };

    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/chat/conversation/${id}`,
        requestOptions
    );
    return res;
}

async function getSalesTargetForecast(conversationId: string) {
    const requestOptions = {
        method: "GET",
    };

    const urlParams = createUrlSearchParams({
        threadId: conversationId,
    });
    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/forecast-sales-target?${
            Boolean(urlParams?.toString()) ? "&" + urlParams?.toString() : ""
        }`,
        requestOptions
    );
    return res;
}

async function saveTargetForecast(data: Record<string, any> | Array<Record<string, any>>) {
    const requestOptions = {
        method: "POST",
        body: JSON.stringify(data),
    };

    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/forecast-sales-target/forecast-configs`,
        requestOptions
    );
    return res;
}
